import { Component, inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonSettings } from 'src/app/models/button-settings.model';
import { Stakeholder } from 'src/app/models/stakeholder.model';
import { StakeholderService } from 'src/app/services/stakeholder.service';
import { ContentCardComponent } from '../../../shared-modules/content-card/content-card.component';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { StakeholdersTableComponent } from './stakeholders-table/stakeholders-table.component';
import { CustomButtonComponent } from '../../../shared-modules/custom-button/custom-button.component';
import { BreadcrumbComponent, BreadcrumbItem } from '../../../shared-modules/breadcrumb/breadcrumb.component';

@Component({
    selector: 'app-stakeholders',
    templateUrl: './stakeholders.component.html',
    styleUrls: ['./stakeholders.component.scss'],
    imports: [ContentCardComponent, MatIcon, MatTooltip, StakeholdersTableComponent, ReactiveFormsModule, CustomButtonComponent, BreadcrumbComponent]
})
export class StakeholdersComponent {
  private formBuilder = inject(FormBuilder);
  private stakeholderService = inject(StakeholderService);
  private router = inject(Router);


  public stakeholderTooltip = 'Onder stakeholders verstaan we personen van partijen van zoals de NS, proRail, lokale vervoerders, de gemeente en de provincie. Deze personen kunnen het handelingsperspectief bewerken en het ov-knooppunt beoordelen.';
  public supportingPartyTooltip = 'Onder ondersteunende partijen verstaan we personen van adviesbureaus of andere partijen die helpen het van het handelingsperspectief trekken/ondersteunen. Deze personen kunnen het handelingsperspectief bewerken, maar geen beoordeling van het ov-knooppunt geven.';

  public buttonSettings: ButtonSettings = {
    fontIcon: 'checklist',
    label: 'Bevestigen',
  }

  public readonly breadcrumbs: BreadcrumbItem[] = [
    { label: 'Home', link: '/landing-page' },
    { label: 'Instellingen', link: '/initialisation' },
    { label: 'Stakeholders uitnodigen' }
  ];

  public stakeholderForm: FormGroup<any>;

  public supportingPartyForm: FormGroup<any>;

  constructor() {
    this.stakeholderForm = this.formBuilder.group({
      items: this.formBuilder.array([])
    });
    this.supportingPartyForm = this.formBuilder.group({
      items: this.formBuilder.array([])
    });
  }

  public stakeholderUpdate(form: FormGroup<any>) {
    this.stakeholderForm = form;
  }

  public supportingPartyUpdate(form: FormGroup<any>) {
    this.supportingPartyForm = form
  }

  public onSubmit() {
    if (this.stakeholderForm.valid && this.supportingPartyForm.valid) {
      const stakeholders: Stakeholder[] = this.formToStakeholders(this.stakeholderForm);
      const supportingParties: Stakeholder[] = this.formToStakeholders(this.supportingPartyForm, true);
      this.stakeholderService.insertStakeholders([...stakeholders, ...supportingParties]).subscribe({
        next: (v: any) => this.router.navigate(['/initialisation']),
        error: (e: any) => console.error(e)
      });
    } else {
      this.markAllAsTouched();
    }
  }

  private formToStakeholders(form: FormGroup<any>, supporting: boolean = false) {
    const items: FormControl[] = (form.get('items') as FormArray).controls as FormControl[]
    const stakeholders: Stakeholder[] = [];

    items.forEach(control => {
      stakeholders.push({
        name: control.get('name')?.value,
        organisation: control.get('organisation')?.value,
        email: control.get('email')?.value,
        supporting: supporting
      });
    });

    return stakeholders;
  }

  private markAllAsTouched() {
    this.stakeholderForm.markAllAsTouched();
    this.supportingPartyForm.markAllAsTouched();
  }
}
